"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.UserMenuLink = exports.LogoutLink = exports.UserIcon = void 0;
/** @prettier */
var react_1 = __importDefault(require("react"));
var Link_1 = require("./Link");
var Icons_1 = require("./Icons");
var UserIcon = function (_a) {
    var firstInitial = _a.firstInitial, lastInitial = _a.lastInitial, restProps = __rest(_a, ["firstInitial", "lastInitial"]);
    return (react_1["default"].createElement("div", __assign({ className: "vs-user-icon-circle" }, restProps),
        react_1["default"].createElement("span", { className: "vs-user-icon-first" }, firstInitial),
        react_1["default"].createElement("span", { className: "vs-user-icon-last" }, lastInitial)));
};
exports.UserIcon = UserIcon;
var LogoutLink = function (_a) {
    var onLogout = _a.onLogout, label = _a.label, restProps = __rest(_a, ["onLogout", "label"]);
    return (react_1["default"].createElement(Link_1.Link, __assign({}, restProps),
        react_1["default"].createElement("a", { onClick: onLogout },
            react_1["default"].createElement(Link_1.LinkContentWrapper, { icon: react_1["default"].createElement(Icons_1.LogoutIcon, null), label: label || 'Logout' }))));
};
exports.LogoutLink = LogoutLink;
var UserMenuLink = function (_a) {
    var onClicked = _a.onClicked, linkIcon = _a.linkIcon, linkLabel = _a.linkLabel, restProps = __rest(_a, ["onClicked", "linkIcon", "linkLabel"]);
    return (react_1["default"].createElement(Link_1.Link, __assign({}, restProps),
        react_1["default"].createElement("a", { onClick: onClicked },
            react_1["default"].createElement(Link_1.LinkContentWrapper, { icon: linkIcon, label: linkLabel }))));
};
exports.UserMenuLink = UserMenuLink;
